import React, { useState } from 'react';

import Tooltip from '../../../components/Tooltip';
import { connect } from 'react-redux';

import {
  hideLightbox,
  setPdfScale,
} from '../../../redux/actions/general/lightbox';

import styles from '../../../styles/containers/Lightbox.scss';

import CloseSmallIcon from '../../../assets/images/close-small-40x40.svg';
import ZoomInIcon from './images/Icon20_ZoomIn.svg';
import ZoomOutIcon from './images/Icon20_ZoomOut.svg';
import Button from '../../../components/CanvasEditor/components/Toolbar/Button';
import { __ } from '../../../core/utils';
import DownloadIcon from '../../../assets/images/download-15x15.svg';
import OutsideClickWrapper from '../../../components/OutsideClickWrapper';

const PdfWrapperHeader = ({ file, pdfScale, onExportPdfWithAnnotations }) => {
  const [openedDownloadOptions, setOpenedDownloadOptions] = useState(false);

  const pdfTools = [
    {
      id: 'zoomIn',
      icon: ZoomInIcon,
      extraClass: ['roundedUp'],
      onClick: () => {
        setPdfScale(Math.min(pdfScale + 0.05, 3));
      },
    },
    {
      id: 'zoomOut',
      icon: ZoomOutIcon,
      onClick: () => {
        setPdfScale(Math.max(pdfScale - 0.05, 0.4));
      },
    },
    // {
    //   id: 'fit',
    //   icon: FitIcon,
    //   onClick: () => {
    //     //viewer.viewport.goHome();
    //   },
    // },
    // {
    //   id: 'fullscreen',
    //   icon: FullScreenIcon,
    //   extraClass: ['withSpacer'],
    //   onClick: () => {
    //     viewer.setFullScreen(!viewer.isFullPage());
    //   },
    // },
  ];

  return (
    <div className={styles.toolbar}>
      <Tooltip text={file.title}>
        <div className={styles.title}>{file.title}</div>
      </Tooltip>
      <div className={styles.rightControls}>
        <div className={styles.pdfTools}>
          {pdfTools.map(({ id, icon, onClick, extraClass }) => (
            <Button
              key={id}
              id={id}
              icon={icon}
              onClick={onClick}
              extraClass={[extraClass]}
              label={__('pdf_reader.toolbar.' + id)}
            />
          ))}
        </div>

        <div className={styles.separator} />

        <DownloadIcon
          className={styles.downloadIcon}
          onClick={() => setOpenedDownloadOptions(true)}
        />

        <div className={styles.separator} />

        {openedDownloadOptions && (
          <OutsideClickWrapper
            onClickOutside={(e) => {
              e.stopPropagation();

              setOpenedDownloadOptions(false);
            }}
          >
            <div className={styles.downloadOptions}>
              {file.download_url && (
                <span
                  onClick={() => {
                    window.open(file.download_url, '_blank');
                    setOpenedDownloadOptions(false);
                  }}
                >
                  {__('files.lightbox.download.original-file')}
                </span>
              )}
              <span
                onClick={() => {
                  onExportPdfWithAnnotations();

                  setOpenedDownloadOptions(false);
                }}
              >
                {__('files.lightbox.download.original-file-with-annotations')}
              </span>
            </div>
          </OutsideClickWrapper>
        )}

        <CloseSmallIcon
          onClick={() => {
            hideLightbox();
          }}
          className={styles.close}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  pdfScale: state.general.lightbox.pdfScale,
});

export default connect(mapStateToProps, null)(PdfWrapperHeader);
